import {customAxios, IDUSUARIO,USERNAME, FDV_URL,PROFORMA_URL,STOCK_URL} from '../constants';
import {FETCH_FICHAS_VENTA, LOADING_FICHAS_VENTA, FETCH_FICHA_VENTA,FETCH_FICHA_VENTA_CORREOS,
    FVTA_WEL_PACK_PROF_VEH,FETCH_VALIDAR_PROFORMA,FETCH_FVTA_WEL_PACK_PROF_VEH,REG_FVTA_WEL_PACK_PROF_VEH} from './types';
import {evalAction, serverError} from '../utils/actionError';

const CANT_X_PAG = 10;
const PAG_1 = 1;

export function fetchFichasVenta(
    codEstado = '[C,V,E,I]',
    nropag = PAG_1,
    cantidadxpag = CANT_X_PAG,
    opcNum = '',
    numero = '',
    tipoFecha = 'fcreacion',
    fecha1 = '',
    fecha2 = '',
    /* codAreaVenta = '',
     codFamilia = '',
     codFilial = '',
     codCia = '',
     codVendedor = '',
     codCliente = '',
     codZona = '',
     tipo = '',
     codMoneda = '',
     codBaumauster = '',
     codTipoPago = '',
     codMonedaCredito = '',
     codClausCompra = '',
     codConfig = '',
     codAdquisicion = '',*/

    codAreaVenta = '',
    codFamilia = '',
    codFilial = '',
    codCia = '',
    codCliente = '',
    codVendedor = '',
    codBaumuster = '',
    codConfiguracion = '',
    codSKU = '',
    codClausula = '',
    codMoneda = '',
    codZona = '',
    codAdquisicion = ''
) {
    let fechaInicio = '';
    let fechaFin = '';
    let fechaInicioCierre = '';
    let fechaFinCierre = '';
    if (tipoFecha === 'fcreacion') {
        fechaInicio = fecha1 ? fecha1.format('DD/MM/YYYY') : '';
        fechaFin = fecha2 ? fecha2.format('DD/MM/YYYY') : '';
    } else if (tipoFecha === 'fcierre') {
        fechaInicioCierre = fecha1 ? fecha1.format('DD/MM/YYYY') : '';
        fechaFinCierre = fecha2 ? fecha2.format('DD/MM/YYYY') : '';
    }

    const config = {
        params: {
            codCia: codCia.length ? `[${codCia}]` : null,
            codAreaVenta: codAreaVenta.length ? `[${codAreaVenta}]` : null,
            codEstado: codEstado.length ? codEstado : null,
            numFichaVenta: opcNum === 'nfdv' ? numero : null,
            numProforma: opcNum === 'nproforma' ? numero : null,
            numPedido: opcNum === 'npedido' ? numero : null,
            fechaInicio,
            fechaFin,
            fechaInicioCierre,
            fechaFinCierre,
            codFamilia: codFamilia.length ? `[${codFamilia}]` : null,
            codFilial: codFilial.length ? `[${codFilial}]` : null,
            codCliente: codCliente.length ? codCliente : null,
            codVendedor: codVendedor.length ? codVendedor : null,
            codBaumuster: codBaumuster.length ? codBaumuster : null,
            codConfig: codConfiguracion.length ? codConfiguracion : null,
            codSKU: codSKU.length ? codSKU : null,
            codClausCompra: codClausula.length ? `[${codClausula}]` : null,
            codMoneda: codMoneda.length ? `[${codMoneda}]` : null,
            codZona: codZona.length ? `[${codZona}]` : null,
            codAdquisicion: codAdquisicion.length ? `[${codAdquisicion}]` : null,

            /*codVendedor: codVendedor.length ? codVendedor : null,
            codCliente: codCliente.length ? codCliente : null,
            codZona: codZona.length ? `[${codZona}]` : null,
            tipo: tipo.length ? `[${tipo}]` : null,
            codMoneda: codMoneda.length ? `[${codMoneda}]` : null,
            codBaumauster: codBaumauster.length ? codBaumauster : null,
            codTipoPago: codTipoPago.length ? `[${codTipoPago}]` : null,
            codMonedaCredito: codMonedaCredito.length ? `[${codMonedaCredito}]` : null,
            codClausCompra: codClausCompra.length ? codClausCompra : null,
            codConfig: codConfig.length ? codConfig : null,
            codAdquisicion: codAdquisicion.length ? `[${codAdquisicion}]` : null,*/
        },
        headers: {
            indpaginado: 'S',
            idUsuario: IDUSUARIO,
            nropag,
            cantidadxpag,
        },
    };

    const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta`, config)
        .then(({data}) => evalAction(data, 'listar'))
        .catch(error => serverError(error, 'listar'))

    return {
        type: FETCH_FICHAS_VENTA,
        payload: request,
    };
}

export function loadFichasVenta() {
    return {
        type: LOADING_FICHAS_VENTA,
    };
}

export function fetchFichaVenta(id) {
    const config = {
        headers: {
            idUsuario: IDUSUARIO,
        },
    };

    const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${id}`, config);

    return {
        type: FETCH_FICHA_VENTA,
        payload: request,
    };
}
/*Inicio Req 92528 ebarboza 28 08 2021 */
export function fetchFichaVentaCorreos(id) {
    const config = {
        headers: {
            idUsuario: IDUSUARIO,
        },
    };

    const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${id}/correos-ficha-vta`, config);

    return {
        type: FETCH_FICHA_VENTA_CORREOS,
        payload: request,
    };
}
/*Inicio Req 92528 ebarboza 28 08 2021 */


/*Inicio Req 93426 ebarboza 29 11 2021*/
export function fetchFichaVentaWelcomePackValidar(numProfVeh) {
    const config = {
        headers: {
            idUsuario: IDUSUARIO,
        },
    };

    const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/num-proforma-veh/${numProfVeh}`, config);

    return {
        type: FVTA_WEL_PACK_PROF_VEH,
        payload: request,
    };
}


export function validateProforma(proforma) {
    const config = {
      headers: {
        idUsuario: IDUSUARIO,
        codUsuario: USERNAME
      },
    };
  const params = {  
    codProforma: proforma,
  };
  
  const request =  customAxios.post(`${PROFORMA_URL}/proforma/verificarReservaProforma`, params,config)
  .then(data => {return data})
  .catch(error => serverError(error, 'listaProforma'))
    return {
        type: FETCH_VALIDAR_PROFORMA,
        payload: request,
    };
  }

  export function fetchWelcomePackValidar(proforma) {
    const config = {
             headers: {
            idUsuario: IDUSUARIO,
            codUsuario: USERNAME,
            numPag: 1,
            cantidadxPag: 10
        }        
    };
    const params = {
        codAreaVta: proforma.codAreaVta,
        codBaumuster: proforma.codBaumuster,
        codFamilia: proforma.codFamilia,
        codMarca: proforma.codMarca,
        codProveedor: "",
        subTipoEquipo: "130",
        tipoCambio: 4.025,
        tipoEquipo: "1",
        tipoMoneda: proforma.codMoneda
    };
    

    const request = customAxios.post(`${STOCK_URL}/equipo/localListar`,params, config);

    return {
        type: FETCH_FVTA_WEL_PACK_PROF_VEH,
        payload: request,
    };
}

export function registrarWelcome(equipoAdicionalLocalList,proforma,fdvID) {
    const config = {
             headers: {
            codUsuario:USERNAME,
            idUsuario:IDUSUARIO
        }        
    };
    const params = {
        numProformaVeh: proforma,
        numFichaVta: fdvID,
        equipoAdicionalLocalList:equipoAdicionalLocalList !==null && equipoAdicionalLocalList !== undefined?equipoAdicionalLocalList:[]
    };
    

    const request = customAxios.post(`${FDV_URL}/ficha-venta/fichas-ventas/welcome-pack`,params, config);

    return {
        type: REG_FVTA_WEL_PACK_PROF_VEH,
        payload: request,
    };
}
/*Fin Req 93426 ebarboza 29 11 2021*/


// WEBPACK FOOTER //
// ./src/actions/FichasVenta.js